import React from 'react';
import '../../../v2-theme.css';

/**
 * V2Input Component
 *
 * Form input with v2 design system styling
 * Matches input styles from HTML files exactly
 *
 * @param {string} label - Input label text
 * @param {string} type - Input type (text, email, password, number, date, time, tel)
 * @param {string} name - Input name attribute
 * @param {string} value - Input value
 * @param {function} onChange - Change handler
 * @param {string} placeholder - Placeholder text
 * @param {boolean} required - Whether input is required
 * @param {string} error - Error message to display
 * @param {boolean} disabled - Whether input is disabled
 * @param {string} min - Min value (for number/date/time inputs)
 * @param {string} max - Max value (for number/date/time inputs)
 * @param {string} step - Step value (for number/time inputs)
 */
const V2Input = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  placeholder = '',
  required = false,
  error = '',
  disabled = false,
  min,
  max,
  step,
  className = '',
  ...props
}) => {
  const inputClasses = [
    'v2-input',
    error ? 'v2-input-error' : '',
    disabled ? 'v2-input-disabled' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className="v2-form-group">
      {label && (
        <label className="v2-label" htmlFor={name}>
          {label}
          {required && <span className="v2-required">*</span>}
        </label>
      )}
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={inputClasses}
        min={min}
        max={max}
        step={step}
        {...props}
      />
      {error && <div className="v2-error-message">{error}</div>}
    </div>
  );
};

export default V2Input;
